import { DefaultPrimaryButton } from '@frontend/components/common';
import { ICONS } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { useActiveModal, useModals } from '@frontend/modal';
import { ToastUtil } from '@frontend/toast-utils';

interface DeleteModalProps {
    func: () => Promise<void>;
    title: React.ReactNode;
    description: React.ReactNode;
    callback?: () => void;
    onDeleteSuccess?: () => void;
    entityName: React.ReactNode;
}

export const DeleteModal = (props: DeleteModalProps) => {
    const { closeModal } = useModals();
    const { modalId } = useActiveModal();

    const onDelete = async () => {
        try {
            await props.func();
            if (props.onDeleteSuccess) {
                props.onDeleteSuccess();
            }
            if (props.callback) {
                props.callback();
            }
            closeModal(modalId);
        } catch {
            ToastUtil.error(CommonMessage.TOAST.DELETE.ERROR(props.entityName));
        }
    };
    return (
        <div className='flex h-full flex-col p-6'>
            <div className='inline-flex w-full items-center justify-between self-stretch'>
                <div className='text-foreground-default justify-start text-3xl font-semibold'>{props.title}</div>
                <div
                    onClick={() => closeModal(modalId)}
                    className='bg-background-surface hover:bg-brand-light border-border-default flex size-11 cursor-pointer items-center justify-center self-center rounded-xl border'>
                    <ICONS.BUTTON.CLOSE_2 className='text-brand-muted size-6' />
                </div>
            </div>
            <div className='text-foreground-default justify-start text-base'>{props.description}</div>
            <div className='inline-flex justify-end'>
                <DefaultPrimaryButton
                    text={CommonMessage.BUTTONS.CONFIRM}
                    onClick={onDelete}
                    styles={{
                        submitButton:
                            'bg-status-danger px-4 py-3 text-base disabled:bg-brand-disabled hover:bg-status-danger/70 inline-flex cursor-pointer items-center justify-center gap-2 rounded-xl disabled:cursor-not-allowed border border-status-danger disabled:border-brand-disabled hover:border-status-danger/70'
                    }}
                />
            </div>
        </div>
    );
};
